import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { HobbyFishing } from './views/HobbyFishing';
import { Background } from './components/Background';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<HobbyFishing />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.HobbyFishing)
	.setHudVisible(true)
	.build();

export default Layout;
